import { tryCatchHelper } from '../../../../helpers';
import {
  allPlanEvaluacionAction,
  onePlanEvaluacionAction,
} from '../plan_evaluacion/PlanEvaluacionAction';
import { ACTIVO_PEVA_ACTIVIDADES } from './PevaActividadesReducer';
import {
  deletePevaActividadesService,
  onePevaActividadesService,
  savePevaActividadesService,
} from './PevaActividadesService';

export const savePevaActividadesAction = async (
  { dispatch, notify },
  idPlanEvaluacion,
  id,
  data,
  paramsPlanEvaluacion,
) => {
  try {
    const res = await savePevaActividadesService(id, data);
    notify(res.data.message);
    await onePlanEvaluacionAction(dispatch, idPlanEvaluacion);
    await allPlanEvaluacionAction(dispatch, paramsPlanEvaluacion);

    return res.data;
  } catch (e) {
    tryCatchHelper({ e, notify });
    return false;
  }
};

export const setActivoPevaActividadesAction = async (dispatch, data) => {
  dispatch({ type: ACTIVO_PEVA_ACTIVIDADES, payload: data });
};

export const onePevaActividadesAction = async (dispatch, id) => {
  const res = await onePevaActividadesService(id);
  if (res.status === 200) {
    await setActivoPevaActividadesAction(dispatch, res.data);
    return true;
  }
  return false;
};

export const deletePevaActividadesAction = async (
  { dispatch, notify },
  idPlanEvaluacion,
  id,
) => {
  try {
    const res = await deletePevaActividadesService(id);
    notify(res.data.message);
    await setActivoPevaActividadesAction(dispatch, null);
    await onePlanEvaluacionAction(dispatch, idPlanEvaluacion);
    return res.data;
  } catch (e) {
    tryCatchHelper(e);
    return false;
  }
};
